import { isOnline } from '@tunasong/models'
import { useEffect, useState } from 'react'

export const useOnlineStatus = () => {
  const [online, setOnline] = useState(isOnline())
  const handleOnline = () => setOnline(true)
  const handleOffline = () => setOnline(false)

  useEffect(() => {
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])
  return online
}
